import React from "react";
import styled from 'styled-components';

const StyledTestPageDiv = styled.div`
  width: 1024px;
  margin: auto;
  height: 100vh;
  box-sizing: border-box;
  padding: 10px;
`;

export default function TestPage() {
  

  return (
    <StyledTestPageDiv>
    </StyledTestPageDiv>
  );
}
